<img [src]="'logos/' + accessService.client.logo">
